import { types } from 'mobx-state-tree'
import { ConvertableDate } from 'store/types/date'

import { Trigger } from '../trigger'
import { Beneficiary } from '../member/beneficiary'

export const InWin = types.model('InWinModel', {
  id: types.identifierNumber,
  amount: types.number,
  date: ConvertableDate,
  trigger: types.reference(Trigger),
  beneficiary: types.reference(Beneficiary),
})
